import React, { useState } from "react";
import "./BookingForm.scss";
import Input from "../../../components/Input/Input";
import Ticket from "../../../components/Ticket/Ticket";
import sweFlag from "../../../assets/sweFlag.png";
import { BsCheck, BsChevronRight } from "react-icons/bs";
import { CgNotes } from "react-icons/cg";
import { BiCheckCircle } from "react-icons/bi";
import Terms from "../Terms/Terms";
import BookingNotes from "../BookingNotes/BookingNotes";
import { useSelector } from "react-redux";
import { calculateCancellation } from "../../../helpers/calculateCancellation";
import { locale } from "../../../translate/sweden";

const BookingForm = (props) => {
  const [toc, setToc] = useState(false);

  const widgetInfo = useSelector((state) => state.widget.widget);

  return (
    <div className="BookingForm" ref={props.refr} onScroll={props.handleScroll}>
      <Ticket staff={props.staff} service={props.service} time={props.time} />
      <div className="form">
        <Input
          label={locale.lastBookingStep.firstName}
          value={props.user.first_name}
          onChange={props.handleFirstNameChange}
          error={props.errors.first_name}
        />
        <Input
          label={locale.lastBookingStep.lastName}
          value={props.user.last_name}
          onChange={props.handleLastNameChange}
          error={props.errors.last_name}
        />
        <Input
          label={locale.lastBookingStep.email}
          type="email"
          value={props.user.email}
          onChange={props.handleEmailChange}
          error={props.errors.email}
        />
        <Input
          label={locale.lastBookingStep.phone}
          phone
          value={props.user.phone}
          onChange={props.handlePhoneChange}
          type="tel"
          error={props.errors.phone}
        >
          <div className="phoneInput">
            <img src={sweFlag} alt="Flag" />
            <p>{locale.lastBookingStep.callNumber}</p>
          </div>
        </Input>
        {props.toc && (
          <div className="checkbox">
            <div
              className={"box" + (toc ? " checked" : "")}
              onClick={() => setToc((p) => !p)}
            >
              <BsCheck />
            </div>
            <div className="toc">
              {locale.iAccept}{" "}
              <span
                onClick={() => props.setTermsOpen(true)}
                style={{
                  color: widgetInfo.company.widget_settings.main_color
                    ? widgetInfo.company.widget_settings.main_color
                    : "#1A73E8",
                  borderColor: widgetInfo.company.widget_settings.main_color
                    ? widgetInfo.company.widget_settings.main_color
                    : "#1A73E8",
                }}
              >
                {locale.terms}.
              </span>
            </div>
          </div>
        )}
        <div
          className={"addBookingNotes" + (props.bookingNotes ? " added" : "")}
          onClick={() => props.setNotesOpen(true)}
        >
          <div className="left">
            <div
              className="notesIcon"
              style={{
                borderColor: !props.bookingNotes
                  ? widgetInfo.company.widget_settings.main_color
                    ? widgetInfo.company.widget_settings.main_color
                    : "#1A73E8"
                  : "#253342",
              }}
            >
              <CgNotes
                style={{
                  color: !props.bookingNotes
                    ? widgetInfo.company.widget_settings.main_color
                      ? widgetInfo.company.widget_settings.main_color
                      : "#1A73E8"
                    : "#253342",
                }}
              />
            </div>
            <p
              style={{
                color: !props.bookingNotes
                  ? widgetInfo.company.widget_settings.main_color
                    ? widgetInfo.company.widget_settings.main_color
                    : "#1A73E8"
                  : "#253342",
              }}
            >
              {props.bookingNotes
                ? locale.lastBookingStep.bookingNotes
                : locale.lastBookingStep.addBookingNotes}
            </p>
            {props.bookingNotes && <BiCheckCircle />}
          </div>
          <BsChevronRight />
        </div>
        {props.staff && (
          <div className="cancellation">
            <h4>{locale.lastBookingStep.cancelationPolicy}</h4>
            <h5>
              {locale.lastBookingStep.cancelFreeFor}{" "}
              <b>
                {calculateCancellation(
                  props.staff.calendar.cancellation_margin
                )}{" "}
              </b>{" "}
              {locale.lastBookingStep.before}.
            </h5>
          </div>
        )}
        <div className="btnWrapper">
          <button
            onClick={props.createAppointmentHandler}
            disabled={props.toc ? !toc : false}
          >
            {locale.lastBookingStep.heading}
          </button>
        </div>
        <div className="formBottom">
          {locale.lastBookingStep.byClickingCompleteBooking}{" "}
          <span>{locale.lastBookingStep.termsAndConditions}</span>
        </div>
      </div>
      {props.termsOpen && (
        <Terms
          toc={props.toc}
          onSave={() => {
            setToc(true);
            props.setTermsOpen(false);
          }}
        />
      )}
      {props.notesOpen && (
        <BookingNotes
          value={props.bookingNotes}
          onChange={(val) => props.handleBookingNotesChange(val)}
          onSave={() => props.setNotesOpen(false)}
        />
      )}
    </div>
  );
};

export default BookingForm;
